import PaymentMethodsList from '@/customComponents/paymentComponents/PaymentMethodsList.jsx'
import HopnCredit from '@/customComponents/paymentComponents/HopnCredit.jsx'

function Payment() {
    return (
        <div className="flex flex-col gap-5 max-md:gap-0">
            <div className="text-lg">
                <h2>Payment & Credit</h2>
                <p>Manage your saved payment methods for easy and secure payments</p>
            </div>
            <div className="flex flex-col-reverse gap-5 md:grid md:grid-cols-12">
                <div className="md:col-span-8">
                    <PaymentMethodsList/>
                </div>
                <div className="md:col-span-4">
                    <HopnCredit/>
                </div>
            </div>
        </div>
    )
}

export default Payment
